<template>
  <div class="additional-pane">
    <div class="additional-pane-item" v-for="(project, index) in list" :key="index">
      <div class="additional-title ">
        <span>{{project.value.title}}</span>
        <span v-if="project.type == 'input'" class="choose-tip">
          <span v-if="project.value.isRequired">
            <!-- 多选 -->
            <span v-if="project.value.isMultipleChoice">
              <span>
                {{'必选'}}{{project.value.minRequiredNum}}，{{'最多选'}}{{project.value.maxMultipleChoiceNum}}
              </span>
            </span>
            <!-- 单选 -->
            <span v-else>
              {{'必选'}}1
            </span>
          </span>
          <span v-else>
            <!-- 多选 -->
            <span v-if="project.value.isMultipleChoice">
              {{'最多选'}}{{project.value.maxMultipleChoiceNum}}
            </span>
            <!-- 单选 -->
            <span v-else>
              {{'最多选'}}1
            </span>
          </span>
        </span>
      </div>
      <component :is="project.type === 'radio'? 'RadioGroup': 'CheckboxGroup'" v-model="project.checkValue" @on-change="update" :disabled="project.disabled" v-if="project.type != 'input'">
        <component :is="project.type === 'radio'? 'Radio': 'Checkbox'" :label="key" v-for="(item, key) in project.value.items" :key="key" custom
                   class="am-margin-right-20 am-margin-top-10 am-vertical-align-top" :disabled="item.disabled">
          <div class="am-flex am-flex-column " slot-scope="{ currentValue }">
            <div class="am-button-custom " :class="{active: currentValue, disabled: item.isSoldOut || item.disabled}">
              <div class="additional-stock-icon" v-if="item.isSoldOut">罄</div>
              <span>{{item.name}}</span>
              <span class="prefix-price-unit">{{currency}}{{item.price}}</span>
            </div>
            <div class="am-text-center additional-stock-wrap" @click.prevent="stopPreventDefault" v-if="item.hasStock">
              <span>库存：</span>
              <span>{{item.stockNum}}</span>
            </div>
          </div>
        </component>
      </component>
      <!-- 多组多选 -->
      <div v-else class="choiceList am-flex-wrap">

        <div v-for="(item, key) in project.value.items" :key="key" class="choiceList-list am-flex" :class="{disabled: item.isSoldOut || item.disabled}">
          <template v-if="item.num <= 0 || project.value.maxMultipleChoiceNum == 1">
            <div class="am-flex am-flex-column " @click="clickNum(item, project.value, key, project)">
              <div class="am-button-custom " :class="{active: project.value.maxMultipleChoiceNum == 1 && item.num > 0, disabled: item.isSoldOut || item.disabled || (typeof item.stockDisabled == 'boolean' && item.stockDisabled)}">
                <div class="additional-stock-icon" v-if="item.isSoldOut">{{ '罄'  }}</div>
                <span class="am-margin-right-xs">{{item.name}}</span>
                <span class="prefix-price-unit">+{{currency}}{{item.price}}</span>
              </div>
            </div>
          </template>
          <div v-else class="choice-item">
            <div class="choiceList-list-left">
              <span class="name am-margin-right-xs">{{item.name}}</span>
              <span class="prefix-price-unit price name">+{{currency}}{{item.price}}</span>
              <span class="sold" v-if="item.isSoldOut">{{ '售罄'  }}</span>
            </div>
            <div class="choiceList-list-right am-flex am-flex-column am-flex-column-center">
              <span class="input-control">
                <div class="additional-sub-reduce am-icon-reduce" @click="reduceNum(item, project.value, key, project)" v-show="item.num > 0"></div>
                <input :value="item.num" class="input-control-content" @blur="numChange(item, project.value, $event, key, project)" v-show="item.num > 0 && (!item.isSoldOut || !item.disabled)">
                <div class="additional-add-plus am-icon-plus" :class="{disabled: (typeof item.stockDisabled == 'boolean' && item.stockDisabled)}" @click="addNum(item, project.value, key, project)"></div>
              </span>
            </div>
          </div>
          <span class="am-text-center additional-stock-wrap" @click.prevent="stopPreventDefault" v-if="item.hasStock && !item.isSoldOut">
                {{ '库存'  }}：{{item.stockNum}}
              </span>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Radio from '@/components/Radio/index'
  import RadioGroup from '@/components/RadioGroup/index'
  import Checkbox from '@/components/Checkbox/index'
  import CheckboxGroup from '@/components/CheckboxGroup/index'

  export default {
    props: {
      value: {
        type: Object,
        default() {
          return {}
        }
      },
      additional: [Object, Array],
      category: [String]
    },
    created() {
    },
    data() {
      let value  = this.$props.value,
          options = value.options,
          list = [];
      list.push(...options);
      return {
        currency: window.currency,
        list
      }
    },
    computed: {
    },
    methods: {
      stopPreventDefault() {

      },
      numChange(item, obj, e, i, p) {
        let self = this;
        let num = e.target.value;
        let count = this.getCellsNum(obj.items);
        let expectCurCellNum = this.getCellsNum(obj.items.filter((o,index) => index !==i)),
        { isMultipleChoice, maxMultipleChoiceNum } = obj,
        { maxSelectNum, hasStock, uid } = item,
        error = false,
        bef_tip = '',
        aft_tip = '',
        msg = "";
        if(hasStock && (this.value.num * num) > this.value.stockObj[uid]) {
          num = Math.floor(this.value.stockObj[uid] / this.value.num);
          error = true;
          msg = item.name + `库存不足，最多可选择${num}`;
        }
        if (maxSelectNum<num && !msg) { // 最多份数判断
          num = maxSelectNum;
          error = true;
          // bef_tip = self.$lang.filter("最多选购");
          // aft_tip = self.$lang.filter("份");
          // if (this.$lang.current == 'en') {
          //   aft_tip = '';
          //   bef_tip = bef_tip.replace(/1/, maxSelectNum);
          //   msg =`${bef_tip}`
          // }else{
          //   msg =`${bef_tip}${maxSelectNum}${aft_tip}`
          // }
          msg = `最多选购${maxSelectNum}份${item.name}噢`;
        }
        if (expectCurCellNum + num > maxMultipleChoiceNum && !msg) {
          error = true; 
          bef_tip = '本分组最多只能选';
          aft_tip = '份';
          // if (this.$lang.current == 'en') {
          //   aft_tip = '';
          //   bef_tip = bef_tip.replace(/1/, maxMultipleChoiceNum);
          //   msg =`${aft_tip}`
          // }else{
          //   msg =`${bef_tip}${maxMultipleChoiceNum}${aft_tip}`
          // }
          msg =`${bef_tip}${maxMultipleChoiceNum}${aft_tip}`
        }
        if (isMultipleChoice && count > maxMultipleChoiceNum && !msg) { // 多选 总数量大于多选限制数量
          num = maxMultipleChoiceNum - expectCurCellNum;
          error = true; 
          bef_tip = '本分组最多只能选';
          aft_tip = '份';
          msg =`${bef_tip}${maxMultipleChoiceNum}${aft_tip}`
        }
        num = Math.max(0, num); // 兼容存在比0小的
        if (error) {
          Com.showToast(msg);
          this.$set(item, 'num', num); // 为了触发视图变化
          this.$forceUpdate();
          return
        }
        this.$set(item, 'num', num);

        this.setCellDisabled(obj.items, obj);
        this.setItemValue(obj, p, i);
        this.update();
      },
      reduceNum(item, data, i, p) {
        if(item.disabled || item.num == 0) return;
        item.num--;
        let cells = data.items;
        this.setCellDisabled(cells, data);
        this.setItemValue(data, p, i);
        this.update();
      },
      clickNum(item, data, i, p) {
        if(item.num <= 0) {
          this.addNum(item, data, i, p);
        }else {
          this.reduceNum(item, data, i, p);
        }
      },
      addNum(item, data, i, p) {
        if(item.addDisabled) {
          let text = item.itemAddDisabled ? `最大选购${item.num}份` : `最多选购${data.maxMultipleChoiceNum}份${data.title}噢`;
          Com.showToast(text);
          return
        }
        if(item.disabled || item.addDisabled || (item.maxSelectNum == item.num) || (typeof item.stockDisabled == 'boolean' && item.stockDisabled)) return;
        if(item.hasStock && this.value.num * (item.num + 1) > this.value.stockObj[item.uid]) {
          let maxStockCanSelectNum = Math.floor(this.value.stockObj[item.uid]/this.value.num);
          return Com.showToast(item.name + `库存不足，最多可选择${maxStockCanSelectNum}`)
        }
        let cells = data.items;
        // 先判断当前组所加数量是否已达最大，是的话需要在第一项(非自己)去掉1，再加
        if(data.maxMultipleChoiceNum == 1) {
          let firstCell = cells.filter((c, cellIndex) => (c.num > 0 && cellIndex !== i));
          firstCell[0] && firstCell[0].num--;
        }
        item.num ++;
        this.setCellDisabled(cells, data);
        this.setItemValue(data, p, i);
        this.update(data);
      },
      getCellsNum(cells) { // 获取当前组已添加的总num
        let num = cells.reduce((a,b)=>Number(a)+Number(b.num), 0)
        return Number(num);
      },
      setCellDisabled(cells, specItem) {
        let selectedTotalNum = this.getCellsNum(cells)
        let maxTotalNum = specItem.maxMultipleChoiceNum;
        cells.forEach(c => {
          c.addDisabled = c.num == c.maxSelectNum || maxTotalNum === selectedTotalNum;
          c.itemAddDisabled = c.num == c.maxSelectNum;
          if(maxTotalNum === 1) {
            c.addDisabled = false;
            c.itemAddDisabled = false;
          }
        })
      },
      setItemValue(item, p, i) {
        if(!item.isMultipleChoice) {
          let selIndex = item.items.findIndex(c => c.num > 0);
          if(~selIndex) {
           p.checkValue = selIndex;
          } else {
           p.checkValue = null;
          }
        } else {
          if(item.items[i].num == 0) {
            p.checkValue = p.checkValue.filter(c => {return c !== i})
          } else if(!p.checkValue.includes(i)) {
            p.checkValue.push(i);
          }
        }
      },
      update() {
        this.$emit('updateAdditional', this.value)
      }
    },
    watch:{
    },
    destroyed() {
    },
    components: {
      RadioGroup,
      Radio,
      CheckboxGroup,
      Checkbox
    }
  }
</script>

<style scoped lang="less">
  .additional-title {
    font-size: 16px;
  }

  .choose-tip {
    font-size: 14px;
    color: #C5C5C5;
  }

  .additional-pane-item {
    margin-bottom: 16px;
  }

  .additional-stock {
    &-wrap {
      color: #c5c5c5;
      font-size: 12px;
      padding-top: 3px;
    }
    &-icon {
      position: absolute;
      background-color: #dbe2e7;
      color: #4c5f70;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      z-index: 2;
      top: -10px;
      right: -5px;
    }
  }
  .am-vertical-align-top {
    vertical-align: top;
  }
  
  .choiceList {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
     .choiceList-list {
      margin-top: 10px;
      margin-right: 20px;
      flex-direction: column;
      justify-content: space-between;
      font-size: 0;

       .choice-item {
        border: 1px solid #3B5D8B;
        border-radius: 2px;
       }
       &-left {
        background: #3B5D8B;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        .name {
          line-height: 30px;
          font-size: 16px;
        }
        .sold {
          width: 48px;
          height: 24px;
          background: #F1F1F1;
          border-radius: 16px 16px 16px 16px;
          font-size: 14px;
          text-align: center;
          display: inline-block;
          color: #C5C5C5;
        }
        .stock {
          font-size: 14px;
          color: #c5c5c5;
        }
       }
       &-right {
        padding: 12px 10px;
        .price {
          font-size: 1.6rem;
          line-height: 30px;
        }
        .input-control {
          font-size: 0;
          &-content {
            margin: 0 4px;
            width: 30px;
            height: 30px;
            border-radius: 4px;
            vertical-align: middle;
            text-align: center;
            border: 1px solid #DBE2E7;
            font-size: 14px;
          }
          .disabled {
            background-color: #F1F1F1;
            color: #C5C5C5;
            cursor: not-allowed;
          }
        }
       }
       &.disabled {
         .name, .input-control, .price {
          opacity: 0.5
        }
       }
     }
   }
</style>



// WEBPACK FOOTER //
// components/business/Additional/Additional.vue